import { motion } from 'framer-motion';

// Animation variants
const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.15,
      delayChildren: 0.2
    }
  }
};

const itemVariants = {
  hidden: { opacity: 0, y: 30 },
  visible: { 
    opacity: 1, 
    y: 0,
    transition: { duration: 0.6, ease: [0.25, 0.1, 0.25, 1] }
  }
};

export const USPSection = () => {
  const usps = [
    {
      title: 'Dokumentation til ESG, drift og energiledelse',
      description: 'Vi dokumenterer energiforbrug før og efter installationen, så virksomheden får konkrete data på besparelse, effektreduktion og energiforbrug. Dokumentationen kan anvendes direkte i ESG-arbejde, energiledelse og intern rapportering.',
    },
    {
      title: 'Intelligent lysstyring',
      description: 'Sensorer, zoner og dagslysstyring sikrer, at belysningen tilpasses bygningens faktiske brug. Det reducerer energispild og giver en mere effektiv drift af bygningens belysning.',
    },
    {
      title: 'Driftssikker implementering',
      description: 'Vi planlægger installationen, så produktion, lager, kontorer og daglig drift påvirkes mindst muligt. Projekterne udføres af faste teams med klare planer og tydelig koordinering.',
    },
  ];

  return (
    <section 
      data-testid="usp-section" 
      className="py-24 md:py-32 bg-white"
    >
      <div className="max-w-[1400px] mx-auto px-8 md:px-16 lg:px-24">
        {/* USPs - Clean minimal style like Neonsign */}
        <motion.div 
          className="grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-16"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-100px" }}
          variants={containerVariants}
        >
          {usps.map((usp, index) => (
            <motion.div
              key={index}
              variants={itemVariants}
              data-testid={`usp-card-${index}`}
            >
              <h3 className="text-lg md:text-xl font-medium text-[#1E2A24] mb-4">
                {usp.title}
              </h3>
              <p className="text-[#1E2A24]/60 leading-[1.8]">
                {usp.description}
              </p>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};
